<template>
  <section
    class="mail"
  >
    <hero
      :image="hero"
      :show_logo="true"
    />
    <heading class="welcome"
      :title="content.title"
    />
    <wysiwyg :content="content.description" />
    <div class="form-wrapper">

    </div>

    <div class="forgot">
      Did not recieve an e-mail?
      <router-link :to="{name: 'auth.login'}">Go here</router-link>
      to request one.
    </div>

  </section>
</template>

<script>
import Hero from '@/sections/section-header/SectionHeader'
import Heading from '@/components/heading/Heading'
import Wysiwyg from '@/components/wysiwyg/Wysiwyg'
import FormWrapper from '@/components/form/FormWrapper.vue'
import InputContainer from '@/components/form/InputContainer.vue'
import HttpError from '@/objects/Exceptions/HttpError'
import Button from '@/components/partials/Button.vue'

export default {
  name: 'RequestSuccess',
  components: {
    Hero,
    Heading,
    FormWrapper,
    InputContainer,
    Button,
    Wysiwyg
  },
  data () {
    return {
      content: {
        title: 'Great! <br/>You\'ve got mail!',
        description: '<p>Check the mail for a magic link to log in.</p>'
      },
      hero: {
        url: '/img/thishostel/header-confirmation.png',
        alt: 'This Hostel'
      },
      code: ''
    }
  },
  computed: {
    email() {
      return this.$store.state.userprofile.profile.email || ''
    }
  },
  methods: {
    async handleSubmit () {
      try {
        await this.$store.dispatch('userprofile/login', {email: this.email, code: this.code})
      } catch (error) {
        this.$router.replace({name: 'auth.login'})
        throw HttpError.parseError(error)
        return
      }

      if (this.$store.state.userprofile.authenticated === true) {
        if (this.$store.state.userprofile.profile.onboarded_at) {
          return this.$router.replace('/')
        }

        return this.$router.replace({name: 'onboarding'})
      }

      return this.$router.replace({name: 'auth.login'})
    }
  },
  mounted () {
  }
}
</script>
<style lang="scss">
  .forgot {
    margin-top: 38px;
    padding-bottom: 40px;
    text-align: center;
    font-size: 0.875rem;
    letter-spacing: 0.11px;
    line-height: 1.25rem;
  }
  .form-wrapper {
    margin-top: 20px;
  }
</style>
